<template>
   <div class="menu-list batt-swap-page">
      <!-- 请选择想要变更的套餐 -->
      <div class="menu-head">{{$t('bstext.bs48')}}:</div>
      <bs-card-menu class="mb12" :overlay="item.overlay" v-for="item in menuList" :key="item.id" :options='item' @click="menuDetail(item)"></bs-card-menu>
      <div class="btn-box">
         <!-- 下一步 -->
      <bs-button class="w100" @click="nextStep">{{$t('bstext.bs5')}}</bs-button>
      </div>
   </div>
</template>

<script>
import utils from '@/utils/index.js'
export default {
   data () {
      return {
         menuList:[],
         cycles:[],
         id:parseInt(this.$route.params.id),
         selId:0
      };
   },
   mounted() {
      this.cycles=this.$t('bsstatus.cycles')
      document.title = this.$t('bstext.bs7')
      this.getServiceList()
   },
   methods: {
      getServiceList(){
         this.$appApi.nativeLoading(true,'',0)         
         let req={
            page:1,
            pageSize:10000,
            excludeSid:this.id,
         }
         this.$server.getServiceList(req).then(res=>{
            let list = res.data.list
            list.forEach((item,index)=> {
               item.overlay=index?true:false
               item.price=utils.formatPrice(item.price)
               item.theme=index%2===0?'yellow':'blue'
               item.cycle=utils.formatStatus(item.cycle,this.cycles)
            });
            this.selId=list[0].id
            this.menuList=list
         }).finally(()=>{
            this.$appApi.nativeLoading(false,'',0)
         })
      },
      menuDetail(item){
         this.selId=item.id
         this.menuList.forEach(item1=>{
            item1.overlay=true
         })
         this.menuList.forEach(item2=>{
            item2.overlay=item2.id===item.id?false:true
         })
      },
      nextStep(){
         this.$router.push(`/bs/battswap/menudetail/${this.selId}?ischange=1`)
      }
   }
}
</script>

<style lang='less' scoped>
.menu-list{
   .menu-head{
      font-size: 16px;
      color: #fff;
      line-height: 20px;
      height: 20px;
      margin: 20px 0;
   }
   .mb12{
      margin-bottom: 12px;
   }
   .btn-box {
      box-sizing: border-box;
      position: absolute;
      bottom: 0;
      left: 0;
      padding: 40px 40px;
      width: 100%;
  }  
}
</style>



// WEBPACK FOOTER //
// src/components/blueshark/battswap/mymenu/selmenulist.vue